import { IApplicationState } from '../../types/redux';

export function showOrderTooltipSelector(state: IApplicationState) {
  return state.flatViewOrder.showTooltip;
}
